import { Account } from 'src/models/account';

export function validData(storeIds: string[], account: Account) {
  return (
    account.master ||
    storeIds.some((_id) => account.storeIds?.includes(_id) ?? false)
  );
}
